module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-3-big-e0066cdc0e9f11cd53a2700089ae1595.jpg";